import { client } from "./client";
import {
  Repo, RepoCreateRequest,
} from "../types/Repo";

export function apiCreateRepo(
  organizationId: number,
  workspaceId: number,
  repoCreateRequest: RepoCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos`,
    repoCreateRequest
  );
}

export function apiGetRepos(
  organizationId: number,
  workspaceId: number
) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos`
  );
}

export function apiPullRepo(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  ) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/pull`
  );
}

export function apiCommitRepo(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  message: string
  ) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/commit`, { message }
  );
}

export function apiPushRepo(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  ) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/push`
  );
}

export function apiGetFileList(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  folder: string,
  page_start = 0,
  page_size = 20,
  filter = "",
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/file_list`,
    { folder_string: folder, page_start, page_size, filter }
  );
}

export function apiGetCodeSearch(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  folder: string,
  searchString: string,
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/code_search`,
    { search: searchString, folder_string: folder }
  );
}

export function apiGetGitInfo(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  folder: string,
  requestType: string,
  count: number,
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/git_info`,
    { request_type: requestType, folder_string: folder, count: count }
  );
}

export function apiOpenFile(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  file_name: string,
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/open_file`,
    { repo_file_name: file_name }
  );
}

export function apiDeleteFile(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  file_name: string,
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/delete_file`,
    { repo_file_name: file_name }
  );
}

export function apiRenameFile(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  file_name: string,
  new_repo_file_name: string,
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/rename_file`,
    { repo_file_name: file_name, new_repo_file_name: new_repo_file_name }
  );
}

export function apiCreateFile(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  file_name: string,
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/create_file`,
    { repo_file_name: file_name }
  );
}

export function apiCreateRepoFolder(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  folder_name: string,
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/create_folder`,
    { repo_folder_name: folder_name }
  );
}

export function apiGetFileData(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  repo_file_name: string,
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/get_file_data`,
    { repo_file_name }
  );
}

export function apiGetLineCounts(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  files: string[],
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/line_counts`,
    { files }
  );
}

export function apiSetFolderLabel(
  organizationId: number,
  workspaceId: number,
  repoId: number,
  folder_path: string,
  label: string,
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/repos/${repoId}/folder_label`,
    { folder_path, label }
  );
}